import { FC, useEffect, useState } from "react";
import { uniqBy } from "ramda";
import Box from "@material-ui/core/Box";
import Delete from "@material-ui/icons/Delete";
import History from "@material-ui/icons/History";

import { MaterialDocument } from "../utils/videosUploadint.utils";
import { Add } from "@material-ui/icons";
import { IconButton, Typography } from "@material-ui/core";

const VideosUpload: FC<VideosUploadProps> = ({ originalVideos, onSelect, progress }) => {
  const [uploadedVideos, setUploadedVideos] = useState<(File | MaterialDocument)[]>([]);

  const handleChange = (event: any) => {
    const uniqFiles = uniqBy((file: File | MaterialDocument) => file.name)([
      ...uploadedVideos,
      ...Array.from(event.target.files),
    ] as any);
    setUploadedVideos(uniqFiles);
    onSelect(uniqFiles);
  };

  const handleDeleteVideo = (file: File | MaterialDocument) => {
    const filteredFiles = uploadedVideos.filter((_file) => _file.name !== file.name);
    setUploadedVideos(filteredFiles);
    onSelect(filteredFiles);
  };

  useEffect(() => {
    setUploadedVideos(originalVideos);
  }, [originalVideos.length]);

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <label htmlFor="video-upload-input" style={{ fontSize: 12 }}>
          <Box
            sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
            style={{ cursor: "pointer" }}
          >
            <Add color="primary" />
            <Typography color="primary">Add Videos</Typography>
            <Typography color="error" style={{ marginLeft: 8 }} variant="body2">
              Plaese select .mp4 or .mov files
            </Typography>
          </Box>
        </label>
        <input
          style={{ display: "none" }}
          value=""
          id="video-upload-input"
          type="file"
          accept=".mov, .mp4"
          multiple
          onChange={handleChange}
        />
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          {progress < 100 && <Typography>{progress}%</Typography>}

          <IconButton onClick={() => setUploadedVideos(originalVideos)}>
            <History />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ p: 1 }}>
        {uploadedVideos.map((file) => (
          <Box
            key={file instanceof File ? `${file.name}_${file.size}` : file.ref?.path}
            sx={{ display: "flex", alignItems: "center" }}
          >
            {file instanceof File ? (
              <div>{file.name}</div>
            ) : (
              <a href={file.input} target="_blank">
                {file.name}
              </a>
            )}

            <IconButton size="small" onClick={() => handleDeleteVideo(file)}>
              <Delete fontSize="small" />
            </IconButton>
          </Box>
        ))}
      </Box>
    </>
  );
};

interface VideosUploadProps {
  originalVideos: any[];
  onSelect: (files: any[]) => void;
  progress: number;
}

export default VideosUpload;
